import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Hero from '../../component/Hero';
import '../../css/home.css';

const Home = () => {
  const [dataLowongan, setDataLowongan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchStatus, setFecthStatus] = useState(true);

  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState({
    salary_min: 0,
    company_name: '',
    company_city: '',
  });

  const handleChangeSearch = (event) => {
    setSearch(event.target.value);
  };

  const handleChangeFilter = (event) => {
    let { name, value } = event.target;

    setFilter({ ...filter, [name]: value });
  };

  const handleSearch = (event) => {
    event.preventDefault();

    axios
      .get('https://dev-example.sanbercloud.com/api/job-vacancy')
      .then(({ data }) => {
        let fetchResult = data.data;

        let result = fetchResult.filter((res) => {
          return Object.values(res)
            .join('')
            .toLowerCase()
            .includes(search.toLowerCase());
        });

        setDataLowongan([...result]);
        setSearch('');
      });
  };

  const handleFilter = (event) => {
    event.preventDefault();
    axios
      .get('https://dev-example.sanbercloud.com/api/job-vacancy')
      .then(({ data }) => {
        let fetchResult = data.data;

        let result = fetchResult.filter((res) => {
          return (
            res.company_city.toLowerCase() ===
              filter.company_city.toLowerCase() ||
            res.salary_min === filter.salary_min ||
            res.company_name.toLowerCase() === filter.company_name.toLowerCase()
          );
        });

        setDataLowongan([...result]);
        setSearch('');
      });
  };

  useEffect(() => {
    let fetchData = async () => {
      try {
        setLoading(true);
        let { data } = await axios.get(
          `https://dev-example.sanbercloud.com/api/job-vacancy`
        );
        setLoading(false);

        let result = data.data;

        setDataLowongan([...result]);
      } catch (error) {
        setTimeout(() => {
          alert('Maaf internet Anda bermasalah');
        }, 5000);
      }
    };

    if (fetchStatus) {
      fetchData();
      setFecthStatus(false);
    }
  }, [fetchStatus, setFecthStatus]);

  return (
    <>
      <div className="container-home">
        <Hero />
        <div className="z-40 items-center py-6 ml-1">
          <form
            onSubmit={handleFilter}
            className="flex flex-col justify-center w-3/4 max-w-sm ml-32 md:flex-row md:w-full md:space-x-3 md:space-y-0"
          >
            <input
              name="salary_min"
              value={filter.salary_min}
              onChange={handleChangeFilter}
              type="number"
              className="px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none w-44 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              placeholder="Salary min..."
            />
            <input
              name="company_city"
              value={filter.company_city}
              onChange={handleChangeFilter}
              type="text"
              className="px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none w-44 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              placeholder="Company city..."
            />
            <input
              name="company_name"
              value={filter.company_name}
              onChange={handleChangeFilter}
              type="text"
              className="px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none w-44 focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              placeholder="Company name..."
            />
            <input
              value={'Filter'}
              className="flex-shrink-0 px-4 py-2 text-base font-semibold text-white bg-purple-600 rounded-lg shadow-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200"
              type="submit"
            />
          </form>
          <form
            onSubmit={handleSearch}
            className="flex flex-col justify-center w-3/4 max-w-sm mt-6 mb-4 md:flex-row md:w-full md:space-x-3 md:space-y-0"
          >
            <input
              value={search}
              onChange={handleChangeSearch}
              type="text"
              className="flex-1 w-full px-4 py-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              placeholder="Search Job Name..."
            />
            <input
              value={'Search'}
              className="flex-shrink-0 px-4 py-2 text-base font-semibold text-white bg-purple-600 rounded-lg shadow-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200"
              type="submit"
            />
          </form>
          <button
            onClick={() => {
              setFecthStatus(true);
            }}
            value={'Search'}
            className="flex-shrink-0 px-4 py-2 mt-4 text-base font-semibold text-white bg-red-600 rounded-lg shadow-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-red-200"
            type="submit"
          >
            Reset Filter
          </button>
          <Link
            to="/dashboard/list-job-vacancy/form/create"
            value={'Search'}
            className="flex-shrink-0 px-4 py-2 mt-4 text-base font-semibold text-white bg-green-600 rounded-lg shadow-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 focus:ring-offset-green-200"
            type="submit"
          >
            Create Data
          </Link>
        </div>
        <div className="container-home_content">
          <h1>Lowongan yang tersedia : </h1>
          {loading && (
            <>
              <div className="w-60 h-24 border-2 rounded-md">
                <div className="flex animate-pulse flex-row items-center h-full justify-center space-x-5">
                  <div className="w-12 bg-gray-300 h-12 rounded-full "></div>
                  <div className="flex flex-col space-y-3">
                    <div className="w-36 bg-gray-300 h-6 rounded-md "></div>
                    <div className="w-24 bg-gray-300 h-6 rounded-md "></div>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="container-home_content-list">
            {dataLowongan.map((res) => {
              return (
                <>
                  <br />
                  <Link to={`/job-vacancy/${res.id}`}>
                    <div className="flex flex-col justify-start gap-4 p-4 bg-white shadow-xl max-h-44 rounded-xl dark:bg-gray-800 md:flex-row">
                      <div className="relative">
                        <img
                          src={res.company_image_url}
                          width={150}
                          height={150}
                          alt="company imageurl"
                        />
                        <span className="absolute px-2 py-1 text-xs text-white bg-gray-700 bg-opacity-50 rounded right-2 bottom-2">
                          7 min
                        </span>
                      </div>
                      <div className="flex flex-col justify-between">
                        <div className="flex items-start justify-between my-2 text-gray-700 dark:text-white md:m-0">
                          <p className="text-xl leading-5">{res.title}</p>
                        </div>
                        <div className="flex items-center my-2 text-xs text-gray-500 dark:text-gray-400 md:m-0">
                          {res.job_status === 1
                            ? 'Lowongan dibuka'
                            : 'Lowongan Ditutup'}
                        </div>
                        <div className="flex items-center my-2 text-xs text-gray-500 dark:text-gray-400 md:m-0">
                          <h5>
                            Minimal Gaji {res.salary_min} - {res.salary_max}
                          </h5>
                        </div>
                        <div className="flex items-start my-2 md:m-0">
                          <div className="flex flex-col items-start justify-center ml-2">
                            <span className="flex items-center text-sm text-gray-600 dark:text-gray-200">
                              {res.company_name}
                              <span className="block w-2 h-2 ml-1 bg-green-500 rounded-full"></span>
                            </span>
                            <span className="text-xs text-gray-400">
                              {res.company_city}, {res.job_tenure} :{' '}
                              {res.job_type}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
